<!-- MOLECULE: AppBarActionButton.vue -->

<script setup lang="ts">
//
// Props
//

withDefaults(
  defineProps<{
    icon: string;
    tooltipText: string;
    loading?: boolean;
    disabled?: boolean;
    onClick?: () => void;
  }>(),
  {
    loading: false,
    disabled: false,
    onClick: () => {},
  },
);
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props }">
      <v-btn icon v-bind="props" color="primary" :disabled="disabled" @click="onClick">
        <!-- Loading state -->
        <v-progress-circular v-if="loading" size="20" width="2" indeterminate color="primary" />

        <!-- Normal state -->
        <v-icon v-else size="default" :icon="icon" />
      </v-btn>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
